module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/services-2-f7a84a75e82742ce4e301af55b266142.png";